<template>
  <div class="modal-content">
    <div class="modal-content__tabs" :class="{ 'single': !isShownMono }">
      <div class="modal-content__tab" @click="activeIndex = 0" :class="{ 'active': activeIndex === 0, 'single': !isShownMono }">
        <img src="/img/svgo/product-page/pay-part_new.svg" alt="">
        <div class="modal-content__tab-info">
          <div class="modal-content__tab-title">Приватбанк</div>
          <div class="modal-content__tab-subtitle">до 8 {{ $t('product_page.payments') }}</div>
        </div>
      </div>
      <div v-if="isShownMono" class="modal-content__tab" @click="activeIndex = 1" :class="{'active': activeIndex === 1}">
        <img src="/img/svgo/product-page/monobank_new.svg" alt="">
        <div class="modal-content__tab-info">
          <div class="modal-content__tab-title">Monobank</div>
          <div class="modal-content__tab-subtitle">до 6 {{ $t('product_page.payments') }}</div>
        </div>
      </div>
    </div>
    <div class="modal-content__description" v-if="activeIndex === 0" v-html="$t('product-page__pay-part-description-pb')"></div>
    <div class="modal-content__description" v-if="activeIndex === 1" v-html="$t('product-page__pay-part-description-mono')"></div>
    <Button @click.native="choosePaypart"
            :class="{ 'disabled': isLoading }"
            class="modal-content__btn"
            size="medium"
            type="primary">
      {{ $t('product-page__pay-part-order') }}
    </Button>
  </div>
</template>

<script>
import Button from '@/components/inputs/Button.vue'
import { mapState } from 'vuex'
import { GoogleEnhancedEcommerce, GoogleTagManagerService } from '@/services/AnalyticService'
import cookieHelper from '@/helpers/cookieHelper'
const PAY_PART_MIN_PRICE = 300
const PAY_PART_MIN_MONO_PRICE = 500
export default {
  name: 'PayPartModalContent',
  components: { Button },
  data () {
    return {
      activeIndex: 0,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      price: state => state.productInfo.productInfo.price,
      code: state => state.productInfo.productInfo.code,
      titleRu: state => state.productInfo.productInfo.titleRu,
      productId: state => state.productInfo.productInfo.productId,
      availableInStore: state => state.productInfo.productInfo.availableInStore,
      inStock: state => state.productInfo.productInfo.inStock,
      formData: state => state.checkout.formData
    }),
    isShownPayPart () {
      return parseInt(this.price) >= PAY_PART_MIN_PRICE
    },
    isShownMono () {
      return parseInt(this.price) >= PAY_PART_MIN_MONO_PRICE
    }
  },
  methods: {
    storeUidForCheckout () {
      return this.formData?.deliveryType?.methodId === 1 &&
      this.formData?.deliveryInfo?.deliverySpot?.uid
        ? this.formData.deliveryInfo.deliverySpot.uid
        : null
    },
    addToCart () {
      this.isLoading = true

      this.$store
        .dispatch('ADD_PRODUCT_TO_CART', {
          productId: this.productId,
          storeId: this.availableInStore ? this.availableInStore.store_id : '',
          storeUid: this.storeUidForCheckout(),
          deliveryType: this.formData.deliveryType ? this.formData.deliveryType.methodId : null,
          esputnikData: this.esputnikData,
          esputnikBlockId: ''
        })
        .then(
          response => {
            this.$store.dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', true)

            const currentProduct = response.products.find(product => product.id === this.productId)
            if (GoogleEnhancedEcommerce.isEnabled) {
              GoogleEnhancedEcommerce.addToCart({
                value: +GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0]).price * parseInt(GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0]).quantity),
                items: [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0])],
                universal_value: this.activeIndex === 0 ? 'Приватбанк - оплата частинами' : 'Monobank - оплата частинами'
              })
            } else {
              GoogleTagManagerService.addToCartEvent({
                analyticsData: currentProduct.analytics_data,
                params: {
                  'event': 'gtm-ee-event-add-to-cart',
                  'gtm-ee-event-action': 'Adding a Product to a Shopping Cart'
                }
              })
            }

            window.gtag('event', 'add_to_cart', {
              'send_to': 'AW-796601565',
              'ecomm_pagetype': window.ecomm_pagetype || 'other',
              'ecomm_prodid': this.code,
              'ecomm_totalvalue': this.price
            })

            window.fbq('track', 'AddToCart', {
              content_name: this.titleRu,
              content_ids: [this.code],
              content_type: 'product',
              value: this.price,
              currency: 'UAH'
            })
          },
          () => {
            this.$modal.show('warning-modal', {
              text: this.$t('product_ends_warning_text'),
              title: this.$t('product_ends_warning_title')
            })
          }
        )
        .finally(() => {
          cookieHelper.setCookie('preferPaypart', this.activeIndex === 0 ? 'pb' : 'mono')
          this.isLoading = false
          window.location.pathname = 'checkout'
        })
    },
    choosePaypart () {
      this.addToCart()
    }
  }
}
</script>
<style lang="sass">
.modal-content
  &__description
    img
      width: 14px
</style>
<style lang="sass" scoped>
.modal-content
  .vue-button
    width: 100%
  &__btn
    &.disabled
      pointer-events: none
  &__tabs
    display: inline-flex
    align-items: stretch
    border-radius: 3px
    background-color: #F3F3F3
    padding: 5px
    margin-bottom: 10px
    +mmax($tablet)
      width: 100%
      &.single
        width: auto
  &__tab
    display: flex
    padding: 5px 19px
    border-radius: 3px
    background-color: transparent
    transition: background-color 0.2s
    align-items: flex-start
    cursor: pointer
    +mmax($tablet)
      width: 50%
      justify-content: center
      &.single
        width: auto
    &.single
      background-color: transparent !important
      padding: 8px 15px
      img
        margin-top: 2px
      .modal-content__tab-info
        display: flex
      .modal-content__tab-subtitle
        margin-left: 10px
        border-left: 1px solid #CCCCCC
        padding: 3px 0 3px 15px
    &.active
      background-color: #fff
    &-title
      font-size: 16px
      font-weight: 500
      line-height: 24px
      color: #333
    &-subtitle
      font-size: 14px
      font-weight: 400
      line-height: 21px
      color: #909090
    img
      width: 20px
      margin-right: 10px
      flex-shrink: 0
      margin-top: 5px
</style>
